module.exports = "<app-header></app-header>\n<p style=\"margin-top: 100px\">\n  404 Connection Error!\n</p>\n<app-footer></app-footer>"